import * as React from "react";
import { store } from '../../../store/index';
import { IInitialState, DataContext, WebChatDTO, TicketStatus, WebChatStatus } from '../../../models/chat.models';
import { webChatService } from '../../../services/webchat.service';

export interface WebChatSendMessageProps { }

export const WebChatSendMessage = (props: WebChatSendMessageProps) => {
  const context: IInitialState = React.useContext(DataContext);
  const inputRef = React.useRef(null);
  
  const cssContent = require('./send-message.css').toString();
  let buttonSendDisable = false;

  const messageTextArea = React.useRef<HTMLTextAreaElement>(null!);

  function disableElement(element: Element) {
    element.setAttribute('disabled', 'true');
  }

  function enableElement(element: Element) {
    element.removeAttribute('disabled');
  }

  function focusHTMLTextAreaElement(element: HTMLTextAreaElement) {
    element.focus();
  }

  async function sendMessage(attachment: string) {
    
    setTimeout(async function () {
      
      if (context.message != '') {
        try {
          disableElement(messageTextArea.current);

          buttonSendDisable = true;
          setButton(buttonSendMessage());

          let msg = context.message;

          let ticketMessageDto = await webChatService.sendMessage({ Message: msg, Session: context.webChatDto.Session, Attachment: attachment });
          
          if (ticketMessageDto) {
            context.webChatDto.Status = WebChatStatus.Active;
            store.dispatch({ type: 'ADD_MESSAGE_TO_LIST', payload: ticketMessageDto });
            store.dispatch({ type: 'SET_MESSAGE', payload: '' });
            store.dispatch({ type: 'SET_MESSAGE_HEIGHT', payload: 56 });

            let chatBotResponseDto = await webChatService.getChatBotMessage({ Message: msg, Session: context.webChatDto.Session, Attachment: attachment });
            if (chatBotResponseDto) {
              store.dispatch({ type: 'ADD_MESSAGE_TO_LIST', payload: chatBotResponseDto });
              store.dispatch({ type: 'SET_MESSAGE', payload: '' });
              store.dispatch({ type: 'SET_MESSAGE_HEIGHT', payload: 56 });
              enableElement(messageTextArea.current);
              focusHTMLTextAreaElement(messageTextArea.current);
            }
          }
        }
        catch(ex) {
        } finally {
          buttonSendDisable = false;
        }
      }
    }, 0);
  }

  function handleClick(e) {
    inputRef.current.click();
  }

  async function onChangeHandler (e){
    if (context.webChatDto && context.webChatDto.Ticket) {
      const path = context.webChatDto.Ticket.Id.toString();
      const attachment = (await webChatService.sendFile(e.target.files[0], path)).fileUrl;
      context.message = webChatService.getTranslations(14, context.webChatSettings);
      await sendMessage(attachment);
    }
  }

  async function onHandleKeyPress(e) {
    if (e.key === 'Enter' && e.shiftKey) {
      //do nothing
    } else if (e.key === 'Enter') {
      // Just enter. We send the message
      sendMessage(null);
    }
  }

  let styleBefore = `.help-desk-conversation-body::before { \
    content: ""; \
    position: absolute; \
    top: 0px; \
    left: 0px; \
    bottom: ${context.messageHeight}px; \
    right: 0px; \
    z-index: 1; \
    pointer-events: none; \
    opacity: 0; \
    background: white; \
    transition: opacity 0.2s ease 0s; \
  }`;

  const [button, setButton] = React.useState(context.message ? buttonSendMessage() : null);//(context.webChatDto && context.webChatDto.ticket ? buttonUpload() : null)

  function buttonUpload() : JSX.Element {
    return <div className="help-desk-composer-upload-button" aria-label="Adjuntar un archivo" role="button" onClick={handleClick.bind(this)}>
      <svg focusable="false" viewBox="0 0 16 18">
        <path d="M14.154 6.918l-.004.003.001-.004-3.287 3.286-.006-.005-3.574 3.574c-.016.017-.03.036-.048.053l-.05.047-.043.041v-.002c-1.167 1.07-2.692 1.331-3.823.2-1.13-1.13-.89-2.677.18-3.843l-.005-.004.074-.073.016-.018c.006-.005.012-.009.017-.016l6.053-6.053.761.76-6.053 6.054-.029.028v.001l-.005.004-.073.074c.011-.01.025-.018.035-.03-.688.75-.93 1.636-.21 2.356.72.72 1.583.456 2.333-.232l-.03.034.04-.042.01-.008.008-.009.033-.03.031-.034.01-.009.007-.009 5.004-5.003.005.006 1.858-1.859c1.223-1.218 1.51-2.913.291-4.132C12.462.806 10.414.74 9.195 1.958L2.248 8.905c.003 0 .006-.002.008-.004-1.625 1.667-1.542 4.43.103 6.074 1.646 1.646 4.474 1.795 6.141.17-.003.002-.004.008-.008.012l.047-.047 6.053-6.054.042-.042.743.78-.025.021.001.002-6.05 6.05-.002.002-.002.001-.046.046h-.002c-2.094 2.04-5.578 1.894-7.652-.18-2.049-2.049-2.15-5.407-.183-7.505l-.006-.005h-.002l.076-.078 6.943-6.944.003-.002.004-.005c1.641-1.64 4.367-1.574 6.008.066 1.64 1.642 1.353 4.014-.288 5.655z" fillRule="evenodd">
        </path>
      </svg>
      <input type="file" name="file" ref={inputRef} style={{ display: "none" }} onChange={onChangeHandler}/>
    </div>;
  }

  function buttonSendMessage() : JSX.Element {
    return <button disabled={buttonSendDisable} className="help-desk-composer-send-button" aria-label="Send a message" onClick={() => { sendMessage(null); }}>
      <svg viewBox="0 0 16 16">
        <path d="M1.388 15.77c-.977.518-1.572.061-1.329-1.019l1.033-4.585c.123-.543.659-1.034 1.216-1.1l6.195-.72c1.648-.19 1.654-.498 0-.687l-6.195-.708c-.55-.063-1.09-.54-1.212-1.085L.056 1.234C-.187.161.408-.289 1.387.231l12.85 6.829c.978.519.98 1.36 0 1.88l-12.85 6.83z" fillRule="evenodd">
        </path>
      </svg>
    </button>
  }

  function handleChange(event: any) {
    
    if (event.target.value) {
      setButton(buttonSendMessage());
    } 
    else if (context.webChatDto && context.webChatDto.Ticket) {
      //setButton(buttonUpload());
      setButton(null);
    }
    else {
      setButton(null);
    }
    let count = ((event.target.value as string).match(/\n/g) || []).length;
    let height = 56 + (count * 18);
    if (height <= 200) {
      store.dispatch({ type: 'SET_MESSAGE_HEIGHT', payload: height });
    }

    store.dispatch({ type: 'SET_MESSAGE', payload: event.target.value });
  }
  
  let textAreaOptions = 
    context.webChatDto && context.webChatDto.Status == WebChatStatus.Closed ? { 'disabled': true, 'placeholder': webChatService.getTranslations(15, context.webChatSettings) } :
    context.webChatDto && context.webChatDto.Ticket && (context.webChatDto.Ticket.Status == TicketStatus.Resolved || context.webChatDto.Ticket.Status == TicketStatus.Closed) 
        ? { 'disabled': true, 'placeholder': webChatService.getTranslations(16, context.webChatSettings) } 
        : { 'placeholder': webChatService.getTranslations(17, context.webChatSettings) };
  
  return (
    <div className="help-desk-send-message-container help-desk-send-message-animation">
      <style>
        {cssContent}
        {styleBefore}
      </style>
      <div className="help-desk-composer">
        <pre style={{height: context.messageHeight}}><br /></pre>
        <textarea ref={messageTextArea}  name="message"
          {...textAreaOptions}
          style={{ height: context.messageHeight }} value={context.message} onChange={handleChange} onKeyUp={onHandleKeyPress}>
        </textarea>
        <div className="help-desk-composer-buttons">
          {(!context.webChatDto.Ticket || (context.webChatDto.Ticket.Status != TicketStatus.Resolved && context.webChatDto.Ticket.Status != TicketStatus.Closed)) 
            && button}
        </div>
      </div>
    </div>
  )
}